export const bannerCta = (): void => {
  const elements = document.querySelectorAll<HTMLElement>('.content-box .cta-box')
  elements.forEach((banner, index) => {
    const btn: HTMLElement | null = banner.querySelector('.btn')
    if (btn) {
      const url = btn.getAttribute('href')
      if (url) {
        const updatedUrl = `${url}_${index + 1}`
        btn.setAttribute('href', updatedUrl)
      }
    }
  })
}

export const bannerWide = (): void => {
  const elements = document.querySelectorAll<HTMLElement>('.content-box .banner-wide')
  elements.forEach((banner, index) => {
    const btn: HTMLElement | null = banner.querySelector('.btn')
    if (btn) {
      const url = btn.getAttribute('href')
      if (url) {
        const updatedUrl = `${url}_${index + 1}`
        btn.setAttribute('href', updatedUrl)
      }
    }
  })
}
